import { atom } from "recoil"
import { UserDetail } from '../connector/type';

const defaultUserDetail: UserDetail = {
  id: '',
  nickname: '',
  level: 0,
  hasThumbnail: false,
  todayComment: '',
  gasMask: false,
  familyNickname: '',
}

const roomsState = atom({
  key: 'rooms',
  default: [{
    id: '',
    owner: '',
    participants: 0,
    uniqueParticipants: 0,
    name: '',
    description: '',
    maxParticipants: 0,
    isPremium: false,
    isSecret: false,
    ownerDetail: defaultUserDetail,
  }]
});

export default roomsState;